import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {Filter, PublicationFilter, PublicationSettings} from './filter';
import {AbstractPaginatedList} from '../abstract-paginated-list';

/**
 * Publication list.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class List extends AbstractPaginatedList<PublicationFilter, PublicationSettings> {
  constructor(container: HTMLElement) {
    super(container);

    ComponentRegistry.wait<Filter>('publication-filter')
      .then(filterPlugin => {
        this.find(filterPlugin.filter);
        filterPlugin.emitter.on('change', () => {
          this.pagination.browse(0);
        });
        this.pagination.emitter.on('browse', paginationSettings => {
          this.settings.start = paginationSettings.start;
          this.find(filterPlugin.filter);
        });
      });

    ComponentRegistry.add('publication-list', this);
  }

  /**
   * Finds publications.
   *
   * @param {PublicationFilter} filter Filter
   */
  protected find(filter: PublicationFilter | null): void {
    filter = AbstractFilter.isFilterEmpty<PublicationFilter>(filter) ? null : filter;
    DataApi.instance.publicationEndpoint.find(this.settings, filter)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/publication/item.handlebars');
          html += template({
            document: document
          });
        }
        this.update(html);

        this.pagination.settings.numFound = response.numFound;
        this.pagination.update();
        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
